import LesseeChargesCard from "../components/LesseeChargesCard";

/**
 * Lessee Charges — dedicated page (Phase 12c).
 *
 * This page is a thin shell that mirrors `DriverCharges.jsx`'s heading
 * structure and renders the existing `<LesseeChargesCard />` component
 * (which already contains the tabs, table, bulk actions, Export CSV, and
 * the "Last 30 days marked charged" audit panel).
 *
 * Auth: admin + accounting only — gated at the route level in `App.js`,
 * symmetric with `/driver-charges`.
 */
export default function LesseeCharges() {
  return (
    <div data-testid="lessee-charges-page">
      <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">
            Lessee Charges
          </h1>
          <p className="mt-1 text-sm text-slate-500">
            Expenses billed back to a lessee company. No Alvys/TMS write — invoicing happens out-of-band.
          </p>
        </div>
      </div>

      <LesseeChargesCard />
    </div>
  );
}
